import React, { FunctionComponent } from 'react';
import { ShareButtonProps } from './types';

export const Presentation: FunctionComponent<ShareButtonProps> = ({ platform, label, url }) => {
  return (
    <li className={`p-article-share-buttons__item p-article-share-buttons__item--${platform === 'facebook' ? 'fb' : 'tw'}`}>
      <a href={url} className="p-article-share-buttons__link" target="_blank" rel="noopener noreferrer">
        {label}
      </a>
    </li>
  );
};
